import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const start = () => {
  i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      /* Wenn die englische Spachversion benötigt wird, bitte Zeile "lng: 'en'" ergänzen */
      /*lng: 'en',*/
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      },
      debug: process.env.NODE_ENV === 'development'
    });
};

export default {
  start
};
